var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-day",class:_vm.classes,on:{"click":function($event){$event.stopPropagation();return _vm.select.apply(null, arguments)},"mouseenter":_vm.hover,"mouseleave":_vm.hoverOut}},[_c('span',{class:['day', _vm.date.format('dddd') === 'Sunday' ? 'sunday' : '']},[_vm._v(" "+_vm._s(_vm.date.date())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }